function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.75 10.083C4.336 10.083 4 9.747 4 9.333C4 6.393 6.243 4 9 4C9.414 4 9.75 4.336 9.75 4.75C9.75 5.164 9.414 5.5 9 5.5C7.07 5.5 5.5 7.22 5.5 9.333C5.5 9.747 5.164 10.083 4.75 10.083Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.75 9.333C17.75 4.323 13.825 0.25 9 0.25C4.175 0.25 0.25 4.324 0.25 9.333C0.25 13.938 3.57 17.745 7.855 18.33L6.155 20.16C6.018 20.305 5.982 20.517 6.062 20.7C6.142 20.882 6.322 21 6.522 21H11.479C11.677 21 11.857 20.882 11.936 20.7C12.016 20.517 11.98 20.305 11.844 20.16L10.144 18.33C14.429 17.745 17.749 13.938 17.749 9.333H17.75ZM9 16.917C5.002 16.917 1.75 13.515 1.75 9.333C1.75 5.151 5.002 1.75 9 1.75C12.998 1.75 16.25 5.15 16.25 9.333C16.25 13.516 12.998 16.917 9 16.917Z"
});

var SvgBalloon = function SvgBalloon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBalloon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/balloon.66f2bfff.svg";
export { ForwardRef as ReactComponent };